/*
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const MapViewIcon = ({ width = 24, height = 24, hidden = false, title = 'Map View' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M25.6 2.106 18 5.905l-7.553-3.777a1 1 0 0 0-.894 0l-7 3.5A1 1 0 0 0 2 6.523v25.764a1 1 0 0 0 1.447.894L10 29.905l7.553 3.776a1 1 0 0 0 .894 0L26 29.905l8.629 3.451A1 1 0 0 0 36 32.428V6.582a1 1 0 0 0-.629-.929l-8.954-3.581a1 1 0 0 0-.817.034ZM18 31.741l-8-4V4l8 4Zm16-.711-8-3.125v-24l8 3.125Z"
    />
  </svg>`;
};
